// Financials — the money, in one place.
//
// Overview is read from Stripe and is the only figure that matches the bank.
// The three tabs after it read Firestore and answer narrower questions: what
// the app itself sold, what the coaching cost, what the club spent. They will
// not add up to Overview, and are not meant to.
import React from 'react';
import ClubReports from './ClubReports';

export default function Financials() {
  return (
    <ClubReports
      title="Financials"
      subtitle="What came in, what it cost, what is left."
      panels={['overview', 'purchases', 'staff', 'expenses']}
    />
  );
}
